__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "AustinEhsContainer";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@amzn/austin-core", "2.166.0", function() { return Promise.all([__webpack_require__.e(91), __webpack_require__.e(397), __webpack_require__.e(961), __webpack_require__.e(905), __webpack_require__.e(975), __webpack_require__.e(744), __webpack_require__.e(199), __webpack_require__.e(349), __webpack_require__.e(333), __webpack_require__.e(292), __webpack_require__.e(175), __webpack_require__.e(773), __webpack_require__.e(373), __webpack_require__.e(31), __webpack_require__.e(570), __webpack_require__.e(422), __webpack_require__.e(318)]).then(function() { return function() { return __webpack_require__("../node_modules/@amzn/austin-core/dist/index.js"); }; }); });
			register("@tanstack/react-query", "5.90.21", function() { return Promise.all([__webpack_require__.e(154), __webpack_require__.e(373), __webpack_require__.e(903), __webpack_require__.e(540)]).then(function() { return function() { return __webpack_require__("../node_modules/@tanstack/react-query/build/modern/index.js"); }; }); });
			register("react-dom", "18.3.1", function() { return Promise.all([__webpack_require__.e(325), __webpack_require__.e(828)]).then(function() { return function() { return __webpack_require__("../node_modules/react-dom/index.js"); }; }); });
			register("react-router-6", "6.29.0", function() { return Promise.all([__webpack_require__.e(744), __webpack_require__.e(284), __webpack_require__.e(175), __webpack_require__.e(329)]).then(function() { return function() { return __webpack_require__("../node_modules/react-router-dom/dist/index.js"); }; }); });
			register("react", "18.3.1", function() { return __webpack_require__.e(696).then(function() { return function() { return __webpack_require__("../node_modules/react/index.js"); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};